import {
  type AnalyticsEventName,
  type AnalyticsEventProps,
} from '@/components/analytics/constants/analytics';

type PlausibleTracker = (
  eventName: AnalyticsEventName,
  options?: {
    props?: AnalyticsEventProps;
  }
) => void;

type WindowWithPlausible = Window & {
  plausible?: PlausibleTracker;
};

export default function trackEvent(
  eventName: AnalyticsEventName,
  props: AnalyticsEventProps = {}
) {
  const plausible = (window as WindowWithPlausible).plausible;

  if (!plausible) {
    return;
  }

  plausible(eventName, {
    props,
  });
}
